
export enum EquipmentEventSubTypeCd {
	FULL_PHOTO = 'FullPhoto',
	THUMBNAIL_PHOTO = 'ThumbnailPhoto',
	TRAILER_PHOTO = 'TrailerPhoto'}

